import { post } from '../request'

//超时未行驶统计接口
export const stayTimeOut = params => {
    return post('/statistics/stayTimeOut', params)
}